import { Card, Chip, ModalContent, useDisclosure } from '@nextui-org/react'
import SelectTank from '../../pages/SelectTank'
import type { SelectedTankArray } from '@/types/view'
import useHomeUpdateStore from '../../store/home/useHomeUpdateStore'
import { useBatchStore } from '../../store/batch/useBatchStore'
import { useGroupStore } from '../../store/group/useGroupStore'
import { BaseModal } from '../common/Modal'

export const SelectUpdateTanks = () => {
  const {
    isOpen: isOpenTanks,
    onOpen: onOpenTanks,
    onOpenChange: onOpenChangeTanks,
  } = useDisclosure()
  const { selectTanksBorderColor, setSelectedTanks, selectedTanks } = useHomeUpdateStore()

  const storedBatchList = useBatchStore((state) => state.batches)
  const batchIds = Object.keys(storedBatchList).filter((batchId) => batchId !== '$empty')
  const getTankRelationsMap = useGroupStore((state) => state.getTankRelationsMap)
  const schoolIdList = getTankRelationsMap()
  return (
    <>
      <div className="mt-3 font-bold">Tanks to Update</div>
      <Card
        className={`${selectTanksBorderColor} border-opacity-60`}
        radius="md"
        shadow="sm"
        isPressable
        onPress={onOpenTanks}
      >
        <BaseModal isOpen={isOpenTanks} onOpenChange={onOpenChangeTanks} size={'2xl'}>
          <ModalContent className="overflow-x-hidden">
            {(onCloseTanks) => (
              <SelectTank
                submitTankArray={(tankSelectedList: SelectedTankArray) =>
                  setSelectedTanks(tankSelectedList, schoolIdList)
                }
                groupIds={batchIds}
                onClose={onCloseTanks}
                initialTankArray={selectedTanks}
              />
            )}
          </ModalContent>
        </BaseModal>
        <div
          className="flex flex-row flex-wrap justify-start p-1 min-h-[3rem] max-h-[10rem] overflow-y-auto"
          style={{ touchAction: 'pan-y', WebkitOverflowScrolling: 'touch' }}
          onClick={(e) => e.stopPropagation()}
          onTouchStart={(e) => e.stopPropagation()}
        >
          {selectedTanks.map((item, index) => (
            <Chip
              key={index}
              radius="md"
              classNames={{
                base: `border-small border-tdpldarkgrey bg-${item.batchName === '$empty' ? 'tdpllightgrey' : 'tdplsky'} border-opacity-60 m-1 p-0`,
                content: 'font-bold',
              }}
            >
              {item.tankName}
            </Chip>
          ))}
        </div>
      </Card>
      {selectTanksBorderColor && selectTanksBorderColor.includes('tdplmaroon') ? (
        <p className="m-0 text-sm font-semibold text-tdplmaroon">Please select Tanks to Update.</p>
      ) : (
        <p></p>
      )}
    </>
  )
}
